import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from 'react-router-dom';
import Header from "../Header/Header";
import foodbrand from "../assets/foodbrand@2x.png";
import { mtUpdateRefAutoTransVial } from "../api/mtUpdateRefAutoTransVial";
import Modal from 'react-bootstrap/Modal';

function ValidarDataVial() {

    const navigate = useNavigate();
    const location = useLocation();
    const preguntas = location.state.preguntas;
    const [preguntasAll, setPreguntasAll] = useState([]);
    const isRunned = useRef(false);
    const [sizeArrayPre, setSizeArrayPre] = useState([]);
    const [show, setShow] = useState(false);
    const [showStatus, setShowStatus] = useState(null);
    const [showMessage, setShowMessage] = useState('');

    const handleClose = () => {
        setShow(false);
    }

    useEffect(() => {
        if (isRunned.current) return;
        isRunned.current = true;

        async function createSession() {
            setSizeArrayPre(preguntas.preguntas.length);
            setPreguntasAll(preguntas);
        }

        createSession();

    }, []);


    const getConfirmar = async () => {

        const objCons = {
            id: localStorage.getItem('idPerson'),
            preguntas: preguntasAll.preguntas
        }

        const dataRefAutoTrans = await mtUpdateRefAutoTransVial(objCons);
        if (dataRefAutoTrans.status === 200) {

            navigate("/PantallaBase27");

        } else {

            setShow(true);
            setShowStatus(dataRefAutoTrans.status);
            setShowMessage(dataRefAutoTrans.message);
            
        }

    }

    const getReintentar = async () => {
        navigate("/PantallaBase27");
    }

    return (
        <>
            <div className="initBack_P2 animate__animated animate__fadeIn">
                <Header
                    imgBack={true}
                    rutaBack="/QuestionExpProfesional"
                    title="Conocimiento vial"
                    name="ValidarData"
                />
                <div className="containerRender">
                    <div className="containerInfo_P2">
                        <div className="containerIdent_P2">
                            <div className='animate__animated animate__fadeIn'>
                                <table>
                                    <tbody>
                                        <tr>
                                            <td>
                                                <p className='txtDocReq_P28'>Preguntas/Questions</p>
                                                <p className='txtIdenOf_P28'>{sizeArrayPre}</p>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <p className="txtDocReq_P28">Estatus/Status</p>
                                                <p className='txtIdenOf_P28'>
                                                    COMPLETADO
                                                </p>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <div className="footer">
                                    <div className="containerCont_P2">
                                        <button className="button_P2" onClick={getConfirmar}>
                                            <span className="txtButton_P2">Aceptar</span>
                                        </button>
                                        <div className="spaceButton14" />
                                        <button className="buttonRein_P2" onClick={getReintentar}>
                                            <span className="txtButtonRein_P14">Reintentar</span>
                                        </button>
                                    </div>
                                    <div className="imageContainer_P2">
                                        <img src={foodbrand} className="imgFooter_P2" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Modal show={show} onHide={handleClose} animation={false} centered>
                <Modal.Body className='backGroudModal'>
                    <div className='msjTitleModalDiv'>Error {showStatus}</div>
                    <div className='msjErrorModal'>{showMessage}</div>
                </Modal.Body>
                <Modal.Footer>
                    <button className='button_P2' onClick={handleClose}>
                        <span className='txtButton_P2'>Regresar</span>
                    </button>
                </Modal.Footer>
            </Modal>

        </>
    );
}

export default ValidarDataVial;
